module.exports = __webpack_public_path__ + "static/media/CTBC-UX-1-cover.18ce8488.png";